import React, {Component} from 'react';
import {compose} from 'redux';
import PropTypes from 'prop-types';

import utilities from '../../utilities/utilities';
import {withRouter} from '../../helpers/routerCompat';

const propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const historyComponent = (WrappedComponent) => {
  class ComponentWrapper extends Component {
    constructor(props) {
      super(props);

      this.isActive = this.isActive.bind(this);
      this.isFront = this.isFront.bind(this);
      this.isDocView = this.isDocView.bind(this);
      this.isCrm = this.isCrm.bind(this);
    }

    getCurrentDoc() {
      const {history} = this.props;
      const pathname = history.location.pathname.split('/');
      if (pathname[1] === 'map') {
        pathname.splice(1, 1);
      }
      if (pathname[4] === 'search') {
        pathname.splice(4, 1);
      }
      return pathname.join('/');
    }

    isActive(url, byPath = false) {
      const {history} = this.props;
      const isMapPage = utilities.isMapPage(history);

      if (process.env.NODE_ENV !== 'development') {
        if ((isMapPage && url === 'map') || (url === 'doc' && !isMapPage)) {
          return ' active';
        }
      }
      else {
        const pathname = history.location.pathname.split('/');
        if (url === pathname[1] || (url === 'doc' && !['map'].includes(pathname[1]))) {
          return ' active';
        }
      }
      if (byPath && url === history.location.pathname) {
        return ' active';
      }
      return '';
    }

    isFront() {
      const {history} = this.props;
      return utilities.isFront(history.location);
    }

    isCrm() {
      const {history} = this.props;
      return history.location.pathname.indexOf('/crm') > -1;
    }

    isDocView() {
      const {history} = this.props;
      const currentDoc = this.getCurrentDoc();
      const isMapPage = utilities.isMapPage(history);

      return !isMapPage && !this.isFront() && currentDoc.indexOf('/edit') < 0;
    }

    render() {
      return (
        <WrappedComponent
          isDocView={this.isDocView}
          isFront={this.isFront}
          isActive={this.isActive}
          isCrm={this.isCrm}
          doc={this.getCurrentDoc()}
          {...this.props}
        />
      );
    }
  }
  ComponentWrapper.propTypes = propTypes;

  return ComponentWrapper;
};

export default compose(
  withRouter,
  historyComponent,
);
